












































































































































































































import {
  defineComponent,
  Ref,
  ref,
  reactive,
  computed,
} from '@vue/composition-api'

import { UserState } from '@/types/store'
import { IUser } from '@/types/user'
import { IReceipt, ReceiptType } from '@/types/receipt'
import { IShop, ChainStore, IChainStore, IChannel } from '@/types/shop'
import useVuex from '@/utils/useVuex'

import { getPlaces } from '@/api/place'

import { AppInput, AppAutocomplete } from '@/components/atoms'

type Props = {
  receipt: IReceipt
  receiptType: ReceiptType
  chainStores: ChainStore[]
  originalPhone: string | null
}

export default defineComponent({
  name: 'SearchFromPhoneModal',
  components: {
    AppInput,
    AppAutocomplete,
  },
  props: {
    receipt: {
      type: Object,
      default: () => ({}),
    },
    receiptType: {
      type: String,
      default: '',
    },
    chainStores: {
      type: Array,
      dafault: [],
    },
    originalPhone: {
      type: String,
      default: null,
    },
  },
  setup(props: Props, context) {
    const store = context.root.$store

    const initialShop = {
      name: '',
      zip: '',
      tel: '',
      prefecture: '',
      address: '',
      latitude: null,
      longitude: null,
    }
    const form = ref<HTMLFormElement | null>(null)
    const showModal = ref<boolean>(false)
    const state = reactive<{
      user: Ref<IUser | null>
      shop: Partial<IShop>
      chainStore: Partial<IChainStore> | null
      channel: Partial<IChannel> | null
      isLoading: boolean
      isPlaceNotFound: boolean
      isShopDuplicated: boolean
      isPreventedFreeDial: boolean
    }>({
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      shop: { ...initialShop },
      chainStore: null,
      channel: null,
      isLoading: false,
      isPlaceNotFound: false,
      isShopDuplicated: false,
      isPreventedFreeDial: false,
    })

    //validation
    const rules = {
      zipRule: [
        (v: any) => !!v || '郵便番号を入力してください',
        (v: any) =>
          /(?:^\d{3}\d{4}$)|(?:^\d{7}$)/.test(v) || '郵便番号が間違っています',
      ],
      prefectureRule: [
        (v: any) => !!v || '都道府県を入力してください',
        (v: any) =>
          [
            '北海道',
            '青森県',
            '岩手県',
            '宮城県',
            '秋田県',
            '山形県',
            '福島県',
            '茨城県',
            '栃木県',
            '群馬県',
            '埼玉県',
            '千葉県',
            '東京都',
            '神奈川県',
            '新潟県',
            '富山県',
            '石川県',
            '福井県',
            '山梨県',
            '長野県',
            '岐阜県',
            '静岡県',
            '愛知県',
            '三重県',
            '滋賀県',
            '京都府',
            '大阪府',
            '兵庫県',
            '奈良県',
            '和歌山県',
            '鳥取県',
            '島根県',
            '岡山県',
            '広島県',
            '山口県',
            '徳島県',
            '香川県',
            '愛媛県',
            '高知県',
            '福岡県',
            '佐賀県',
            '長崎県',
            '熊本県',
            '大分県',
            '宮崎県',
            '鹿児島県',
            '沖縄県',
          ].indexOf(v) > -1 || '都道府県を正しく入力してください',
      ],
      latitudeRule: [
        (v: any) =>
          !v ||
          /\d{2}\.\d{1,7}/.test(v) ||
          '小数点以下7桁以内で記入してください',
      ],
      longitudeRule: [
        (v: any) =>
          !v ||
          /\d{3}\.\d{1,7}/.test(v) ||
          '小数点以下7桁以内で記入してください',
      ],
      telRule: [
        (v: any) =>
          /^0[1-9]\d{8}$/.test(v) ||
          /^0[5-9]0\d{8}$/.test(v) ||
          '電話番号が正しくありません',
      ],
    }
    const validate = () => {
      if (!form.value) {
        return false
      }
      return form.value?.validate()
    }

    const onChangePhone = (phone: string) => {
      state.isShopDuplicated = false
      context.emit('on-change-phone', phone)
    }

    const clickSearchGoogle = async () => {
      if (!state.shop.tel) {
        return
      }
      state.isLoading = true
      state.isPlaceNotFound = false
      const places = await getPlaces(state.shop.tel)
      onChangePhone(state.shop.tel)
      if (places.length > 0) {
        const place = places[0]
        state.shop = {
          ...state.shop,
          name: (place.name || '').replace(/店$/, ''),
          zip: place.zip || '',
          prefecture: place.prefecture || '',
          address: place.address || '',
          latitude:
            place.latitude === null
              ? 0
              : Math.round(place.latitude * 10e7) / 10e7,
          longitude:
            place.longitude === null
              ? 0
              : Math.round(place.longitude * 10e7) / 10e7,
        }
      } else {
        state.isPlaceNotFound = true
      }
      state.isLoading = false
      return
    }

    const isNgChainStore = computed<boolean>(() => {
      if (state.chainStore === null) {
        return false
      }
      return state.chainStore.ng_flag === true
    })

    const canReflectEdited = computed(() => {
      if (state.isLoading) {
        return false
      }
      if (
        state.shop === null ||
        state.chainStore === null ||
        state.channel === null
      ) {
        return false
      }
      if (state.shop.name && state.shop.name.length > 0) {
        return validate()
      }
      return false
    })

    const isNewShop = computed<boolean>(() => {
      if (props.originalPhone === null) {
        return false
      }
      return props.originalPhone !== props.receipt.phone
    })

    const clickEdit = async () => {
      showModal.value = true
      state.shop =
        props.receipt.shop === null ? { ...initialShop } : props.receipt.shop
      state.chainStore = props.receipt.chainStore
      state.channel = props.receipt.channel
      state.shop.tel = props.receipt.phone === null ? '' : props.receipt.phone
    }

    const onChangeShopName = (name: string) => {
      // if (state.shop === null) {
      //   throw new Error()
      // }
      state.shop = {
        ...state.shop,
        name,
      }
    }

    const onSelectChainStore = (cs?: ChainStore) => {
      if (cs === undefined) {
        // if (state.shop === null) {
        //   throw new Error()
        // }
        state.shop = {
          ...state.shop,
          chain_store_id: -1,
        }
        state.chainStore = null
        state.channel = null
        return
      }
      const name = state.shop?.name || ''
      // if (state.shop === null) {
      //   throw new Error()
      // }
      state.shop = {
        ...state.shop,
        name,
        chain_store_id: cs.id,
      }
      const { channel, ...remains } = cs
      state.chainStore = {
        ...remains,
        channel: {
          ...channel,
          created_at: null,
          updated_at: null,
          deleted_at: null,
          chainStores: [],
        },
      }
      state.channel = channel
    }

    const onChangePlace = (key: string, value: string | number) => {
      // if (state.shop === null) {
      //   return
      // }
      state.shop = {
        ...state.shop,
        [key]: value,
      }
    }

    const clickApply = async () => {
      // if (state.shop === null) {
      //   return
      // }
      if (state.user === null) {
        return
      }
      let shop: Partial<IShop> = {
        ...state.shop,
        name: state.shop.name,
        // eslint-disable-next-line @typescript-eslint/camelcase
        group_name: state.chainStore?.name || '',
        // eslint-disable-next-line @typescript-eslint/camelcase
        corporate_name: state.chainStore?.name || '',
        zip: state.shop.zip ? state.shop.zip.replace(/[-]/, '') : '',
        tel: props.receipt.phone,
        prefecture: state.shop.prefecture || '',
        address: state.shop.address || '',
        latitude: state.shop.latitude || 0,
        longitude: state.shop.longitude || 0,
        // eslint-disable-next-line @typescript-eslint/camelcase
        chain_store_id: state.chainStore?.id || -1,
        adminApprovedAt: new Date(),
        approvedByAdminId: state.user.id,
      }
      if (props.receiptType !== 'shopUnchecked') {
        shop.leaderAppliedAt = new Date()
        shop.appliedByLeaderId = state.user.id
      }
      if (isNewShop.value || shop.id === undefined) {
        try {
          shop = await store.dispatch('shop/postShop', shop)
        } catch (e) {
          if (e.code === 400) {
            state.isPreventedFreeDial = true
          } else {
            state.isShopDuplicated = true
          }
          return
        }
      } else {
        try {
          shop = await store.dispatch('shop/putShop', shop)
        } catch (e) {
          if (e.code === 400) {
            state.isPreventedFreeDial = true
          } else {
            state.isShopDuplicated = true
          }
        }
      }

      const newReceipt: IReceipt = {
        ...props.receipt,
        shopId: shop.id || null,
        shop: shop as IShop,
        chainStoreId: shop.chainStore?.id || null,
        chainStore: shop.chainStore || null,
        channelId: shop.chainStore ? shop.chainStore.channel.id : null,
        channel: shop.chainStore ? shop.chainStore.channel : null,
        needReProcess: false,
      }
      if (props.receipt.chainStoreId !== newReceipt.chainStoreId) {
        // chainStore変更
        newReceipt.needReProcess = true
      }
      context.emit('on-click-reflect-result', newReceipt)
      context.emit('on-change-is-shop-modified', true)

      state.shop = { ...initialShop }
      state.isLoading = false
      state.isPlaceNotFound = false
      showModal.value = false
    }

    const cancelSearch = () => {
      state.shop = { ...initialShop }
      state.isLoading = false
      showModal.value = false
    }

    return {
      showModal,
      state,
      isNgChainStore,
      canReflectEdited,
      clickEdit,
      clickSearchGoogle,
      onChangeShopName,
      onSelectChainStore,
      onChangePlace,
      clickApply,
      cancelSearch,
      isNewShop,
      rules,
      form,
    }
  },
})
